import axios from 'axios'
import { APIHELPER } from '@/constants'
import { sessionHelper } from '@/utils'
import store from '@/state/store'
import qs from 'qs'

export function apiHelper(baseURL, appendAuthHeader = true, checkTokenExpired = true) {
  let authHeader = {}
  let userType = sessionHelper.getUserType();
  let userToken = sessionHelper.getUserToken();
  let staffToken = sessionHelper.getStaffUserToken();
  let staffExpiredTime = sessionHelper.getStaffUserExpiredTime();
  let staffRefreshExpiredTime = sessionHelper.getStaffUserRefreshExpiredTime();
  let expiredTime = sessionHelper.getUserExpiredTime();
  let refreshExpiredTime = sessionHelper.getUserRefreshExpiredTime();

  if(userType == "ADMIN") {
    if (userToken && appendAuthHeader) {
      authHeader.Authorization = `Bearer ${userToken}`
    }
  }
  else {
    if (staffToken && appendAuthHeader) {
      authHeader.Authorization = `Bearer ${staffToken}`
    }
  }

  const apiInstance = axios.create({
    baseURL,
    paramsSerializer(params) {
      return qs.stringify(params, { arrayFormat: 'indices', encodeValuesOnly: true })
    }
  })

  async function checkExpired() {
    if(userType == "ADMIN") {
      if(checkTokenExpired == true) {
        var tokenExpired = sessionHelper.isTokenExpired();
        if (tokenExpired == true) {
          var refreshTokenExpired = sessionHelper.isRefreshTokenExpired();
          if (refreshTokenExpired == true) {
           await store.dispatch('auth/logout');
          }
          else {
           await store.dispatch('auth/refreshToken');
          }
        }
      }
    }

    else {
      if(checkTokenExpired == true) {
        var staffTokenExpired = sessionHelper.isStaffTokenExpired();
        if (staffTokenExpired == true) {
          var staffRefreshTokenExpired = sessionHelper.isStaffRefreshTokenExpired();
          if (staffRefreshTokenExpired == true) {
           await store.dispatch('auth/staffLogout');
          }
          else {
           await store.dispatch('auth/staffRefreshToken');
          }
        }
      }
    }
    
  }

  const responseHandler = (response) => {
    return response.data
  }

  const errorHandler = async (error) => {
    var errorMessage = "";
    var errorReturnMessage = "";
    var errorType = "";
    var errorKey = "";
    var errorResponse = error.response;
    var errorStatus = 0;
    var errorData = null;
    if (!errorResponse) {
      errorMessage = error.message;

      if (errorMessage === APIHELPER.NETWORK_ERROR) {
        errorReturnMessage = APIHELPER.NETWORK_ERROR;
      }
      else {
        errorReturnMessage = APIHELPER.UNKNOWN_ERROR;
      }
    }
    else {
      errorStatus = error.response.status;
      switch (errorStatus) {
        case 401:
          console.log(error.response.data.error);
          if(error.response.data.error) {
            errorReturnMessage = error.response.data.error
          }
          else {
            errorReturnMessage = APIHELPER.INVALID_USER;
          }
          await checkExpired();
          break;
        case 400:
          errorType = typeof error.response.data.error;
          errorData = error.response.data.error;

          console.log('abcd');
          console.log(errorData);

          if (errorType === APIHELPER.OBJECT) {

            Object.keys(errorData).map(
              (key) => {
                if (errorKey === '') {
                  errorKey = key;
                } else {
                  errorKey += ',' + key;
                }
              }
            );

            errorReturnMessage = errorKey + APIHELPER.OBJECT_INVALID;
          }
          else {
            errorReturnMessage = errorData;
          }
          break;
        default:
          errorReturnMessage = error.response.data.error;
      }
      error.response.data.alertMessage = errorReturnMessage;
      throw error
    }
  }


  apiInstance.interceptors.request.use(async (config) => {
    if(userType == "ADMIN") {
      if (userToken) {
        if(!expiredTime && !refreshExpiredTime) {
          await store.dispatch('auth/logout');
        }
        await checkExpired();
      }
      userToken = sessionHelper.getUserToken(); 

      if (userToken && appendAuthHeader) {
        config.headers = {
          ...config.headers,
          Authorization: `Bearer ${userToken}`,
        }
      }
    }
    else {
      if (staffToken) {
        if(!staffExpiredTime && !staffRefreshExpiredTime) {
          await store.dispatch('auth/staffLogout');
        }
        await checkExpired();
      }
      staffToken = sessionHelper.getStaffUserToken();

      if (staffToken && appendAuthHeader) {
        config.headers = {
          ...config.headers,
          Authorization: `Bearer ${staffToken}`,
        }
      }
    }

    

    return config
  })

  apiInstance.interceptors.response.use(
    (response) => responseHandler(response),
    (error) => errorHandler(error)
  )

  return apiInstance
}
